import { Page, Text, StyleSheet, View } from "@react-pdf/renderer";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import FieldsTable from "../../components/FieldsTable";

const ObjectPage = ({
  object,
  id,
  title,
  author,
  createdDate,
  groupsFields,
  config,
  screenshots,
}) => {
  const styles = StyleSheet.create({
    page: {
      backgroundColor: "white",
      color: "#303030",
      fontFamily: "Inter",
      fontSize: 9,
      padding: "30px 55px 118px",
    },

    anchor: {
      position: "absolute",
      top: 0,
      left: 0,
    },

    h1: {
      fontSize: 18,
      lineHeight: 1.4,
      fontWeight: 600,
    },

    groupTitle: {
      fontSize: 12,
      lineHeight: 1.4,
      fontWeight: 600,
      marginBottom: 5,
      marginTop: 15,
    },
  });

  return (
    <Page size="A4" dpi={72} style={styles.page}>
      <View id={id} style={styles.anchor}></View>

      <Header createdDate={createdDate} config={config} />

      <Text style={styles.h1}>{title}</Text>

      {/* Разделы объекта */}
      {groupsFields.map((group) => {
        return (
          <View key={group.uuid} id={group.uuid}>
            <Text style={styles.groupTitle}>{group.name}</Text>

            <FieldsTable
              fields={group.fields || []}
              object={object}
              screenshots={screenshots}
            />
          </View>
        );
      })}

      <Footer createdDate={createdDate} author={author} />
    </Page>
  );
};

export default ObjectPage;
